import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import Field                from '../../Field';

let Validation = require('../../Managers/Validation.js');
let Config = require('Config');
let Quote = require('../../Managers/Quote.js');

class Employer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEmploymentPermanent: null,
        };
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillUpdate() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
        this.childComponents = [];
    }

    getChildInputComponents() {
        let inputComponents = [];
        inputComponents = inputComponents.concat(this.inputComponents);
        this.childComponents.filter(component => {
            return (component !== null) && (component !== undefined);
        }).map(component => {
            inputComponents = inputComponents.concat(component.getChildInputComponents());
        });

        return inputComponents;
    }

    /**
     * Handles state switching between two different API fields while answering
     * only one question.
     *
     * @param e
     */
    handleJobType(e) {
        switch (e) {
            case 0:
                // Full time job, zero hours = false
                Quote.set('jobType', 0, this.props.source);
                Quote.set('isZeroHour', false, this.props.source);
                break;
            case 1:
                // Part time job, zero hours = false
                Quote.set('jobType', 1, this.props.source);
                Quote.set('isZeroHour', false, this.props.source);
                break;
            case 3:
                // Zero hours contract, job = part time by default
                Quote.set('jobType', 1, this.props.source);
                Quote.set('isZeroHour', true, this.props.source);
                break;
        }
    }

    /**
     * Callback to the parent that the employment is changing and we need to
     * show the next financial referee fields.
     *
     * @param v
     */
    handleEmploymentChanging(v) {
        if (this.props.callbackFunction) {
            this.props.callbackFunction(v);
        }
    }

    /**
     * Sets whether or not the employment is permanent, calls the
     * handleEmploymentChanging method for passing back up the chain.
     *
     * @param v
     */
    handleDurationUpdate(v) {
        this.setState({ isEmploymentPermanent: v });
    }

    /**
     * Handles deletion of values from one field that answers two different
     * questions in IRIS.
     */
    unmountQuestions() {
        Quote.deleteByPath(this.props.source + '.jobType');
        Quote.deleteByPath(this.props.source + '.isZeroHour');
    }

    render() {
        let index = this.props.financialRefereeStatus - 1;
        return(
            <div className="question-section">
                <question-row class="header-row">
                    <h2>Employed</h2>
                </question-row>

                {/* Xpress - only ask for salary and bonus/overtime */}
                {this.props.productId === 11 ?
                    <div>
                        <Field
                            type="money"
                            fieldName={'annual_salary' + index}
                            question="Current basic annual salary"
                            storageKey="applicantAnnualIncome"
                            dataValidation="2_decimal_money"
                            loadValues={true}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.applicantAnnualIncome'}
                            placeholder="Before tax deduction I earn..."
                            helpText="The salary should be relevant to this employer only."
                            source={this.props.source}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />

                        <Field
                            type="money"
                            fieldName={'overtime' + index}
                            question="Annual earnings from overtime, bonus and/or commission"
                            storageKey="applicantAnnualOvertime"
                            dataValidation="2_decimal_money.non_mandatory"
                            loadValues={true}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.applicantAnnualOvertime'}
                            placeholder="Before tax deduction I earn..."
                            source={this.props.source}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />
                    </div>
                :
                    <div>
                        <Field
                            fieldName={'companyName' + index}
                            question="Company Name"
                            storageKey="companyName"
                            type="text"
                            maxLength={60}
                            dataValidation="required_field"
                            loadValues={true}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.companyName'}
                            source={this.props.source}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />

                        <Field
                            fieldName={'employerAddress' + index}
                            type="address"
                            question="Company postcode"
                            storageKey="address"
                            addressOptions={{
                                pafLookup: true,
                                canHaveManualEntry: true,
                                canBeForeign: true,
                                hasManualEntryOption:true,
                            }}
                            loadValues={true}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.address'}
                            source={this.props.source + '.address'}
                            ref={(instance) => {
                                this.inputComponents.push(instance);
                                this.childComponents.push(instance);
                            }}
                        />

                        <Field
                            fieldName={'referee_name' + index}
                            question="Name of authorised referee"
                            storageKey="contactName"
                            type="text"
                            maxLength={70}
                            helpText="An authorised referee may be someone from HR, Payroll, or someone in a senior position to yourself."
                            dataValidation="alpha_and_space_only"
                            source={this.props.source}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.contactName'}
                            loadValues={true}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                            forcibleValidation
                        />
                        <Field
                            fieldName={'referee_position' + index}
                            question="Referee position"
                            storageKey="contactPosition"
                            type="text"
                            maxLength={70}
                            dataValidation="required_field"
                            source={this.props.source}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.contactPosition'}
                            loadValues={true}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />
                        <Field
                            fieldName={'referee_mobile_number' + index}
                            question="Referee mobile number (UK only)"
                            storageKey="mobile"
                            type="text"
                            maxLength={11}
                            dataValidation="mobile_number.non_mandatory"
                            helpText={'Providing a mobile number for your employer can help speed up the application process.'}
                            source={this.props.source}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.mobile'}
                            loadValues={true}
                            ref={(instance) => { this.inputComponents.push(instance); }}
                            inValidOverride={() => { return Validation.doesFinancialRefereeNumberMatchApplication(index, 'mobile'); }}
                        />
                        <Field
                            type="email"
                            fieldName={'referee_email' + index}
                            storageKey="email"
                            question="Referee email"
                            dataValidation="email_address.non_mandatory"
                            source={this.props.source}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.email'}
                            loadValues={true}
                            inValidOverride={() => {
                                let applicationEmail = Quote.getByPath('BaseIndividualApplication.email');
                                let finRefEmail = Quote.getByPath('BaseIndividualApplication.financialReferees.' + index + '.email');

                                // dont validate if either email is blank
                                if (window.uornorb(applicationEmail) || window.uornorb(finRefEmail)) {
                                    return {
                                        isValid: true,
                                        hasError: false,
                                        errors: [],
                                    };
                                } else {
                                    if (applicationEmail == finRefEmail) {
                                        return {
                                            isValid: false,
                                            hasError: true,
                                            errors: ["Email must not be the same as tenant contact details"],
                                        };
                                    } else {
                                        return {
                                            isValid: true,
                                            hasError: false,
                                            errors: [],
                                        };
                                    }
                                }
                            }}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />
                        <Field
                            fieldName={'referee_phone_number' + index}
                            question="Referee telephone number"
                            storageKey="phone"
                            type="text"
                            maxLength={20}
                            dataValidation="phone_number"
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.phone'}
                            loadValues={true}
                            source={this.props.source}
                            inValidOverride={() => { return Validation.doesFinancialRefereeNumberMatchApplication(index, 'phone'); }}
                            ref={(instance) => { this.inputComponents.push(instance); }}
                        />
                        <Field
                            fieldName={'applicantPositionHeld' + index}
                            question="Your job title"
                            type="text-with-selection-list"
                            storageKey="applicantPositionHeld"
                            maxLength={70}
                            dataValidation="required_field"
                            source={this.props.source}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.applicantPositionHeld'}
                            loadValues={true}
                            // selectionOptions={JobLookup.companyApiLookup()} @TODO: tom fix this
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />
                        <Field
                            fieldName={'payroll_number' + index}
                            question="Payroll or employee number"
                            storageKey="payrollNumber"
                            type="text"
                            maxLength={32}
                            dataValidation={'required_field.non_mandatory'}
                            helpText="A payroll or employee number can help your employer locate your records."
                            source={this.props.source}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.payrollNumber'}
                            loadValues={true}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />
                        <Field
                            fieldName={'national_insurance_number' + index}
                            storageKey="nationalInsuranceNumber"
                            question="Your National Insurance number"
                            type="text"
                            maxLength={9}
                            dataValidation={'alpha_and_space_only.non_mandatory'}
                            helpText="A National Insurance number can help your employer locate your records."
                            source={this.props.source}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.nationalInsuranceNumber'}
                            loadValues={true}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />

                        <Field
                            fieldName={'start_date' + index}
                            storageKey="employmentStartDate"
                            question="Your employment start date"
                            type="date"
                            subType="full"
                            dataValidation="required_field"
                            source={this.props.source}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.employmentStartDate'}
                            loadValues={true}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />

                        <Field
                            fieldName={'position' + index}
                            question="What type of position is it?"
                            storageKey="isPermanent"
                            type="button-choice"
                            options={[
                                {
                                    value: true,
                                    text: 'Permanent'
                                },
                                {
                                    value: false,
                                    text: 'Temporary'
                                }
                            ]}
                            dataValidation="required_field"
                            source={this.props.source}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.isPermanent'}
                            loadValues={true}
                            callbackFunction={this.handleDurationUpdate.bind(this)}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />

                        {this.state.isEmploymentPermanent === false ?
                            <Field
                                type="date"
                                subType="end-date"
                                fieldName={'end_date' + index}
                                storageKey="employmentEndDate"
                                question="When will your contract be ending?"
                                loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.employmentEndDate'}
                                loadValues={true}
                                dataValidation="end_date"
                                source={this.props.source}
                            />
                        : null}

                        <Field
                            question="What type of employment is it?"
                            fieldName={'duration' + index}
                            type="button-choice"
                            options={[
                                {
                                    value: 0,
                                    text: 'Full time'
                                },
                                {
                                    value: 1,
                                    text: 'Part time'
                                },
                                {
                                    value: 3,
                                    text: 'Bank or Zero Hour'
                                }
                            ]}
                            dataValidation="required_field"
                            callbackFunction={this.handleJobType.bind(this)}
                            overwriteDefaultValue={() => {
                                let jobType = Quote.getByPath(this.props.source + '.jobType');
                                let isZeroHour = Quote.getByPath(this.props.source + '.isZeroHour');
                                if (isZeroHour) {
                                    return 3;
                                } else {
                                    if (jobType == 'Parttime' || jobType == 1) {
                                        return 1;
                                    } else if (jobType == 'Fulltime' || jobType == 0) {
                                        return 0;
                                    }
                                }
                            }}
                            loadValues={true}
                            onUnmount={this.unmountQuestions.bind(this)}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />

                        <Field
                            type="money"
                            fieldName={'annual_salary' + index}
                            question="Current basic annual salary"
                            storageKey="applicantAnnualIncome"
                            dataValidation="2_decimal_money"
                            placeholder="Before tax deduction I earn..."
                            helpText="The salary should be relevant to this employer only."
                            source={this.props.source}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.applicantAnnualIncome'}
                            loadValues={true}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />

                        {!window.uorn(window.localStorage.getItem('BankValidationStrategy')) ?
                            <div>
                                <Field
                                    fieldName={'payment_frequency' + index}
                                    type="select"
                                    question="Frequency of pay"
                                    storageKey="frequencyOfPay"
                                    source={this.props.source}
                                    loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.frequencyOfPay'}
                                    loadValues={true}
                                    isInt={true}
                                    options={[
                                        {
                                            option_value: Config.financialRefereePaymentFrequencies.WEEKLY,
                                            option_text: "Weekly"
                                        },
                                        {
                                            option_value: Config.financialRefereePaymentFrequencies.MONTHLY,
                                            option_text: "Monthly"
                                        },
                                        {
                                            option_value: Config.financialRefereePaymentFrequencies.TWO_WEEKLY,
                                            option_text: "2 weekly"
                                        },
                                        {
                                            option_value: Config.financialRefereePaymentFrequencies.FOUR_WEEKLY,
                                            option_text: "4 Weekly"
                                        }
                                    ]}
                                />

                                <Field
                                    type="text"
                                    fieldName={'tax_code' + index}
                                    storageKey={'taxCode'}
                                    question="My tax code"
                                    dataValidation="tax_code.non_mandatory"
                                    maxLength={8}
                                    source={this.props.source}
                                    loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.taxCode'}
                                    loadValues={true}
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                />
                            </div>
                        : null}

                        <Field
                            type="money"
                            fieldName={'overtime' + index}
                            question="Annual earnings from overtime, bonus and/or commission"
                            storageKey="applicantAnnualOvertime"
                            dataValidation="2_decimal_money.non_mandatory"
                            placeholder="Before tax deduction I earn..."
                            source={this.props.source}
                            loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.applicantAnnualOvertime'}
                            loadValues={true}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                        />

                        {/* Don't ask if the employment is likely to change in the tenancy period if it's the third financial referee */}
                        {this.props.source !== 'BaseIndividualApplication.financialReferees.2' && this.props.source !== 'EmploymentFinancialReferee' ?
                            <Field
                                question={'Do you see this employment changing in the next ' + this.props.termLength + ' months?'}
                                fieldName={'changing' + index}
                                type="button-choice"
                                options={[
                                    {
                                        value: true,
                                        text: 'Yes'
                                    },
                                    {
                                        value: false,
                                        text: 'No'
                                    }
                                ]}
                                callbackFunction={this.handleEmploymentChanging.bind(this)}
                                ref={(instance) => { this.inputComponents.push(instance); }}
                            />
                        : null}

                        <Field
                            fieldTitle="Fast Track"
                            fieldName={'evidence' + index}
                            question="You can help reduce the time it takes to complete your referencing application by providing us with evidence of your income."
                            storageKey="evidence"
                            type="upload"
                            contextInfo={'Employer evidence'}
                            labelExtra="Please provide evidence of your income by selecting one of the options below. You must ensure that any evidence clearly displays the payment amount, dates paid and your name."
                            helpText={'For this reference, suitable documents are:<ul><li>Copies of the last three months payslips (or payslips since joining the company if less than three months)</li><li>If you\'re paid weekly, you can provide two payslips from each month</li><li>A job offer letter or contract of employment (if it is a future employer)</li><li>If your contract of employment or job offer letter does not confirm your start date or salary, we will need to contact your employer to verify this information</li></ul>'}
                            allowFileUploads={true}
                            allowCameraUploads={true}
                            source={this.props.source}
                        />
                    </div>
                }
            </div>
        );
    }
}

Employer.propTypes = {
    productId:                  PropTypes.number.isRequired,
    termLength:                 PropTypes.number,
    source:                     PropTypes.string.isRequired,
    financialRefereeStatus:     PropTypes.oneOf([1, 2, 3]),
    callbackFunction:           PropTypes.func,
};

Employer.defaultProps = {
    isSlim: false,
};

export default Employer;


// WEBPACK FOOTER //
// ./src/components/Screens/Sections/Employer.js